var _circle, _circle2, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAverageSpeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14,
    transform: "matrix(-1 0 0 1 30 0)",
    fill: "white",
    stroke: "url(#paint0_linear_2609_19013)",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 10.5,
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 5V7.4",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12L15 18",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 18C16.75 18.9665 15.9665 19.75 15 19.75C14.0335 19.75 13.25 18.9665 13.25 18C13.25 17.0335 14.0335 16.25 15 16.25C15.9665 16.25 16.75 17.0335 16.75 18Z",
    fill: "#00A651",
    stroke: "black",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1198 15.4156C25.1422 14.0478 24.9011 12.6934 24.4102 11.4297C23.9193 10.166 23.1882 9.01784 22.2587 8.05066C21.3292 7.08348 20.2194 6.31627 18.9928 5.79284C17.7662 5.26941 16.4468 5 15.1099 5C13.7729 5 12.4447 5.26941 11.2009 5.79284C9.95714 6.31627 8.82225 7.08348 7.86104 8.05066C6.89982 9.01784 6.13109 10.166 5.59875 11.4297C5.06641 12.6934 4.78088 14.0478 4.75845 15.4156H8.32169C8.33626 14.5265 8.52186 13.6462 8.86788 12.8248C9.2139 12.0034 9.71358 11.2571 10.3384 10.6284C10.9632 9.99973 11.7008 9.50104 12.5093 9.16081C13.3177 8.82058 14.1811 8.64546 15.0501 8.64546C15.9191 8.64546 16.7768 8.82058 17.574 9.16081C18.3713 9.50104 19.0927 9.99973 19.6968 10.6284C20.301 11.2571 20.7762 12.0034 21.0953 12.8248C21.4144 13.6462 21.5711 14.5265 21.5566 15.4156H25.1198Z",
    fill: "url(#paint1_linear_2609_19013)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2609_19013",
    x1: 1.05132e-9,
    y1: 15.0242,
    x2: 30,
    y2: 14.9758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A651"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007ABC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2609_19013",
    x1: 4.5,
    y1: 15.5,
    x2: 25.4944,
    y2: 15.1558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A651"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#CACA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62828"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAverageSpeed);
export default __webpack_public_path__ + "static/media/average-speed.86ab2a1e6464074a834039cb03541866.svg";
export { ForwardRef as ReactComponent };